import BaseCard from './BaseCard';
import { CardType } from './CardType';
import GameObject from '../../../GameObject/GameObject';
import Container from '../../Container';
import { ICardModifierData } from './ICardModifierData';
import { ModifierTypeMap } from './ModifierTypeMap';
import { CardModifierType } from './CardModifierType';
import AnimationFrame from '../../../Component/AnimationFrame';
import Point from '../../../Utility/Point';
import Game from '../../../Game';
import { Random } from '../../../Utility/Random';

enum GoldSuit {
    CLUB = 'gold_card_2',
    DIAMOND = 'gold_card_3',
    HEART = 'gold_card_4',
    SPADES = 'gold_card_1',
}

export default class GoldCard extends BaseCard {
    public isBlocked: boolean = true;
    private idleSprite: AnimationFrame;
    private interval: any;

    protected onCreate(params: any): void {
        params.cardFrontTexture = this.getGoldSuit(params.suit);
        params.cardBackTexture = this.getGoldSuit(params.suit);
        params.type = CardType.gold;
        super.onCreate(params);

        // Why is this here?
        const animationContainer = GameObject.Instantiate(Container, {
            name: 'animationContainer',
            visible: params.faceUp,
        });
        this.addChild(animationContainer);

        this.idleSprite = GameObject.Instantiate(AnimationFrame, {
            name: 'gold_sprite',
            resourceName: 'gold_card_animation',
            animationName: 'animation_gold_card',
            autoStart: false,
            frameRate: 1000 / 120,
            anchor: Point.Center,
        });
        this.addChild(this.idleSprite);
    }

    private getGoldSuit(suit: number): GoldSuit {
        switch (suit) {
            case 0:
                return GoldSuit.CLUB;
            case 1:
                return GoldSuit.HEART;
            case 2:
                return GoldSuit.SPADES;
            case 3:
                return GoldSuit.DIAMOND;
            default:
                return undefined;
        }
    }

    public startIdleAnimation(): void {
        this.idleSprite.start();
        Game.ticker.setTimeout(() => {
            this.idleSprite.stop();
        }, 1350);
        if (this.interval) {
            Game.ticker.clearInterval(this.interval);
            this.interval = null;
        }
        this.interval = Game.ticker.setInterval(() => {
            this.idleSprite.start();
            setTimeout(() => {
                this.idleSprite.stop();
            }, 1350);
        }, 5000 + Random.int(0, 350));
    }

    public destroy() {
        if (this.interval) {
            Game.ticker.clearInterval(this.interval);
            this.interval = null;
        }
        super.destroy();
    }

    public static async preload(): Promise<void> {
        Game.resource.add(
            'gold_card_animation',
            'resource/graphics/sprite_sheets/gold_card_animation.json'
        );
    }  
}
